import {WinPresentationInitialState} from '@fantasmagames/slot/src/modules/winpresentation/states/WinPresentationInitialState';
import {WinUtils} from '@fantasmagames/slot/src/logic/WinUtils';
import {WinPresentationEvents} from '@fantasmagames/slot/src/modules/winpresentation/WinPresentationEvents';
import {Timer} from '@fantasmagames/core/src/update/Timer';
import {GameRecodeLogic} from 'src/logic/recode/GameRecodeLogic';
import {WinPresentationModule} from '@fantasmagames/slot/src/modules/winpresentation/WinPresentationModule';
import {RecodeLogic} from '@fantasmagames/slot/src/logic/integration/RecodeLogic';
import {SpinButtonEvents} from '@fantasmagames/slot/src/modules/keypad/spinbutton/SpinButtonEvents';

export class GameWinPresentationInitialState extends WinPresentationInitialState {

	protected _isBounceFinished: boolean = false;
	protected _isWinNumberShown: boolean = false;

	protected _currentWPTimer: Timer;

	public onEnterState(): void {
		super.onEnterState();

		this._isBounceFinished = false;
		this._isWinNumberShown = false;
	}

	public onLeaveState(): void {
		super.onLeaveState();

		this.killWPTimer();
	}

	protected setupEvents(): void {
		super.setupEvents();

		this.on(WinPresentationEvents.WIN_NUMBER_BOUNCE_FINISHED, this.onWinNumbersBounceFinished);
		this.on(WinPresentationEvents.WIN_NUMBER_SHOWN_TO_PLAYER, this.onWinNumberShown);
	}

	protected killWPTimer(): void {
		if (this._currentWPTimer) {
			this._currentWPTimer.stop();
			this._currentWPTimer = null;
		}
	}

	protected onWinNumberShown(): void {
		this._isWinNumberShown = true;
		this.tryToFinishWinPresentation();
	}

	protected onWinNumbersBounceFinished(): void {
		this._isBounceFinished = true;
		this.tryToFinishWinPresentation();
	}

	protected tryToFinishWinPresentation(): void {
		if (this._isWinNumberShown && this._isBounceFinished) {
			this.killWPTimer();

			const logic: RecodeLogic = this.module.logic as RecodeLogic;
			const duration: number = logic.getTotalWildMeterDeltas() < 3 ? 800 : 2000;

			this._currentWPTimer = new Timer(() => {
				this.onWinAnimationFinished();
			}, duration, true);
			this.module.updateManager.add(this._currentWPTimer);

			this._isBounceFinished = false;
			this._isWinNumberShown = false;
		}
	}

	protected startInitialWinPresentation(): void {
		const logic: GameRecodeLogic = (this.module.logic as GameRecodeLogic);

		if (logic.getWin() > 0) {
			this.view.playWinNumberCounter(logic.getWin(),
				WinUtils.isRoundExcellentWin(logic),
				0,
				false);
		}

		this.emit(WinPresentationEvents.INITIAL_ANIMATION_STARTED);
	}

	protected onWinAnimationFinished(): void {
		this.emit(SpinButtonEvents.ENABLE_SPIN_BY_SPIN);
		this.emit(WinPresentationEvents.INITIAL_ANIMATION_FINISHED);

		this.view.killCurrentWinPresentation();
		this.view.playWinEndAnimation();
		this.view.forceKillWinNumbers();

		this.module.gotoState(WinPresentationModule.BASIC);
	}
}



// WEBPACK FOOTER //
// ./src/winpresentation/states/GameWinPresentationInitialState.ts